<template>
  <v-container fluid class="px-4 pt-0">
    <v-row>
      <v-col>
        <v-tabs v-model="selectedTab">
          <v-tab v-show="canViewForms">FORMS</v-tab>
          <v-tab v-show="canViewMaterialRequests">REQUESTED MATERIALS</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <inventory-allocation-forms v-if="selectedTab === 0"/>     
        <inventory-allocation-materials v-if="selectedTab === 1"/> 
      </v-col>    
    </v-row>

  </v-container>
</template>

<script>
import InventoryClassSelectElement from '@/components/elements/InventoryClassSelectElement.vue';
import InventoryAllocationInitForm from '@/components/forms/inventoryAllocation/InventoryAllocationInitForm.vue';
import InventoryMaterialRequestForm from '@/components/forms/inventoryAllocation/InventoryMaterialRequestForm.vue';
import InventoryAllocationForm from '@/components/forms/inventoryAllocation/InventoryAllocationForm.vue';
import InventoryAllocationForms from './InventoryAllocationForms.vue';
import InventoryAllocationMaterials from './InventoryAllocationMaterials.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    InventoryClassSelectElement,
    InventoryAllocationInitForm,
    InventoryMaterialRequestForm,
    InventoryAllocationForm,
    InventoryAllocationForms,
    InventoryAllocationMaterials,
  },
  data: () => ({
    selectedTab: 0
  }),
  computed: {
    ...mapGetters([
      'checkUserPermission',
    ]),
    canViewForms() {
      return this.checkUserPermission(['Admin', 'Allocation Admin'])
    },
    canViewMaterialRequests() {
      return this.checkUserPermission(['Admin', 'Allocation Admin', 'Material Handler', 'Material Requester'])
    }
  },
  mounted() {
    if (this.canViewForms) {
      this.selectedTab = 0;
    } else if (this.canViewMaterialRequests) {
      this.selectedTab = 1;
    } else {
      this.$router.push('/');
    }
  }
};
</script>